var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 432,
    viewBox: "0 0 1440 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497 58.9058C505.25 60.5309 522.662 62.2556 560 27.9058C582.838 11.306 588.912 22.0891 600.5 27.9058C616.589 30.4726 658.578 56.5753 682 53.5587C699.922 53.5421 751.078 34.5751 764 43.0587C775.172 50.2922 783.412 47.9222 793.5 48.4057C799.589 48.6392 853.245 51.2557 865.5 61.9058C872.755 64.056 881.75 66.7809 883 74.4058C882.75 82.5308 883 379.5 883 379.5H497C497 379.5 497.25 66.0308 497 58.9058Z",
    fill: "#0647AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194 4.56021C167 24.0602 101 65.5602 92 69.5602C33.6 69.5602 5.33333 51.8925 -1.5 43.0586V431.559H1440.5V32.5586C1426.5 46.5586 1333 64.5586 1302 64.5586C1271 64.5586 1215 22.0586 1186 22.0586C1157 22.0586 1093 82.0586 1016.5 82.0586C940 82.0586 894 54.0602 863 55.0602C832 56.0602 561.5 64.5586 527.5 55.0602C493.5 45.5618 428.5 42.0586 399.5 64.5586C370.5 87.0586 314 77.0602 287.5 55.0602C261 33.0602 221 -14.9398 194 4.56021Z",
    fill: "#0647AA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096 279.971L1116.99 268.309L1137.98 279.971V373.852H1096V279.971Z",
    fill: "#5FC6F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.27 244.983L1287.26 233.32L1308.25 244.983V373.268L1266.27 373.268V244.983Z",
    fill: "#5FC6F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1307.09 288.135L1328.08 276.473L1349.07 288.135V373.853H1307.09V288.135Z",
    fill: "#4CB3DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1347.91 202.75H1357.11V159.784H1365.55V129.094H1388.57V159.784H1397.01V202.75H1406.22V373.848H1347.91V202.75Z",
    fill: "#72CBF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233.62,
    y: 187.254,
    width: 44.3167,
    height: 186.597,
    fill: "#72CBF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233.62,
    y: 276.473,
    width: 44.3167,
    height: 96.797,
    fill: "#5FC6F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1406.22,
    y: 250.816,
    width: 45.4829,
    height: 123.62,
    fill: "#87D1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1387.56 375.602V223.992L1424.88 243.818V375.602H1387.56Z",
    fill: "#5FC6F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1158.98 375.017V236.469L1196.3 256.295V375.017L1158.98 375.017Z",
    fill: "#4CA8CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1127.49 260.729H1134.49V228.075H1140.9V204.75H1158.39V228.075H1164.81V260.729H1171.8V373.853L1127.49 373.853V260.729Z",
    fill: "#72CBF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1185.8,
    y: 233.906,
    width: 44.3167,
    height: 139.947,
    fill: "#72CBF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1238.28 303.296V295.133H1289.59V303.296H1286.1V373.853H1241.78V303.296H1238.28Z",
    fill: "#43A3CB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.082 273.971L362.493 262.309L341.904 273.971V367.852H383.082V273.971Z",
    fill: "#5FC6F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.087 238.983L195.498 227.32L174.909 238.983V367.268L216.087 367.268V238.983Z",
    fill: "#5FC6F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.044 282.135L155.456 270.473L134.867 282.135V367.853H176.044V282.135Z",
    fill: "#4CB3DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.018 196.75H126.987V153.784H118.71V123.094H96.1343V153.784H87.8566V196.75H78.8265V367.848H136.018V196.75Z",
    fill: "#72CBF3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.4652,
    height: 186.597,
    transform: "matrix(-1 0 0 1 248.105 181.254)",
    fill: "#72CBF3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.4652,
    height: 96.797,
    transform: "matrix(-1 0 0 1 248.105 270.473)",
    fill: "#5FC6F1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.6091,
    height: 123.62,
    transform: "matrix(-1 0 0 1 78.8208 244.816)",
    fill: "#87D1F4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.6091,
    height: 265.9,
    transform: "matrix(-1 0 0 1 34.2129 103)",
    fill: "#87D1F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1279 369.602V217.992L60.5256 237.818V369.602H97.1279Z",
    fill: "#5FC6F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.319 369.017V230.469L284.717 250.295V369.017L321.319 369.017Z",
    fill: "#4CA8CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.201 254.729H345.338V222.075H339.047V198.75H321.889V222.075H315.598V254.729H308.735V367.853L352.201 367.853V254.729Z",
    fill: "#72CBF3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.4652,
    height: 139.947,
    transform: "matrix(-1 0 0 1 295.003 227.906)",
    fill: "#72CBF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.541 297.296V289.133H193.212V297.296H196.644V367.853H240.109V297.296H243.541Z",
    fill: "#43A3CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.27f1f21ce3a1bced336f78fb59e535a0.svg";
export { ForwardRef as ReactComponent };